import globalAxios from 'axios';

/* tslint:disable */
/* eslint-disable */
/**
 * Recommendation API
 * API documentation for zootopia (recommendation-engine)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: Team_Dev_MadDragons@zooplus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
const BASE_PATH = 'http://localhost'.replace(/\/+$/, '');
/**
 *
 * @export
 */
const COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|',
};
/**
 *
 * @export
 * @class BaseAPI
 */
class BaseAPI {
    basePath;
    axios;
    configuration;
    constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
class RequiredError extends Error {
    field;
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = 'RequiredError';
    }
}

export { BASE_PATH, BaseAPI, COLLECTION_FORMATS, RequiredError };
//# sourceMappingURL=base.js.map
